<template>
  <div id="headers">
    <div class="headerBox">
      <h1 class="flt">
        <img id="logo" alt="logo" src="../../assets/images/home/logo.png" />
      </h1>
      <nav class="frt navList hidden-xs-only">
        <!-- <ul class="navCatList">
          <li
            v-for="(item, idx) in navList"
            :key="idx"
            :class="navActive === item.path ? 'navActive' : ''"
            @click="navCat(item.path)"
          >
            {{ item.name }}
          </li>
        </ul> -->

        <el-menu
          :default-active="navActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="navCat"
        >
          <template v-for="(item, idx) in navList">
            <el-menu-item v-if="!item.son" :index="item.path" :key="idx">{{
              item.name
            }}</el-menu-item>

            <el-submenu :index="item.path" v-if="item.son" :key="idx">
              <template slot="title">{{ item.name }}</template>
              <el-menu-item
                v-for="(son, idxs) in item.son"
                :key="idxs"
                :index="son.path"
                >{{ son.name }}</el-menu-item
              >
            </el-submenu>
          </template>
        </el-menu>
      </nav>
      <div class="phoneNav frt hidden-sm-and-up">
        <el-button
          icon="el-icon-more"
          class="frt"
          circle
          plain
          @click="cascaderPanel = true"
        ></el-button>
      </div>
    </div>
    <el-cascader-panel
      v-show="cascaderPanel"
      v-model="navActive"
      :options="navList"
      @change="navCat"
      :props="{
        label: 'name',
        value: 'path',
        children: 'son'
      }"
    ></el-cascader-panel>
    <el-dialog
      title="在线申请"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      width="550px"
      custom-class="joinDialog"
    >
      <div class="popContent">
        <aside class="popSun flt">
          <label>姓名</label>
          <el-input
            class="flt"
            size="small"
            placeholder="请输入姓名"
            v-model="postData.username"
            clearable
          >
          </el-input>
        </aside>

        <aside class="popSun flt">
          <label>性别</label>
          <el-radio v-model="postData.gender" label="男">男</el-radio>
          <el-radio v-model="postData.gender" label="女">女</el-radio>
          <el-radio v-model="postData.gender" label="保密">保密</el-radio>
        </aside>

        <aside class="popSun flt">
          <label>电话</label>
          <el-input
            class="flt"
            size="small"
            placeholder="请输入电话号码"
            v-model="postData.phone"
            clearable
          >
          </el-input>
        </aside>
        <aside class="popSun flt">
          <label>代理区域</label>
          <el-select
            size="small"
            v-model="postData.agency_area"
            placeholder="请选择代理区域"
          >
            <el-option
              v-for="item in options"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </aside>
        <aside class="popSun flt">
          <label>加盟公司全称</label>
          <el-input
            class="flt"
            size="small"
            placeholder="请输入公司全称"
            v-model="postData.company_name"
            clearable
          >
          </el-input>
        </aside>
        <aside class="popSun flt" style="width: 100%; height: 104px;">
          <label>基本情况</label>
          <el-input
            type="textarea"
            :rows="3"
            class="flt"
            placeholder="请输入基本情况"
            v-model="postData.basic_information"
            clearable
          >
          </el-input>
        </aside>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="popConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GoBaseUrl } from "../../config/fetch.js";
import "element-ui/lib/theme-chalk/display.css";
export default {
  name: "headers",
  data() {
    return {
      navList: [
        {
          name: "首页",
          path: "home"
        },
        {
          name: "硬件产品",
          path: "contentUnion"
        },
        {
          name: "解决方案",
          path: "platform",
          son: [
            { name: "云平台", path: "platform" },
            { name: "智慧消防", path: "introduceSon" },
            { name: "智慧维保", path: "maintenanceSon" },
            // { name: "应急指挥", path: "emergencySon" },
            { name: "智慧社区", path: "communitySon" }
          ]
        },
        {
          name: "合作案例",
          path: "projectCase"
        },
        {
          name: "新闻中心",
          path: "newindex"
        },
        {
          name: "APP下载",
          path: "",
          son: [
            {
              name: "消防APP",
              path: "xf"
            },
            {
              name: "维保APP",
              path: "wb"
            },
            {
              name: "维保APP2.0",
              path: "wb2"
            }
          ]
        },
        {
          name: "关于安讯",
          path: "aboutUs",
          son: [
            {
              name: "联系我们",
              path: "contactUs"
            },
            {
              name: "资质证书",
              path: "certificate"
            },
            // {
            //   name: "新闻中心",
            //   path: "pressCenter"
            // },
            {
              name: "招商加盟",
              path: "joinUs"
            },
            {
              name: "入驻维保平台",
              path: "entryInstructions"
            },

          ]
        }
      ],
      navActive: "home",
      dialogVisible: false,
      postData: {
        username: "",
        gender: "男",
        join_area: "这个字段以去掉",
        phone: "",
        company_name: "",
        agency_area: "",
        basic_information: ""
      },
      options: [
        "北京市",
        "天津市",
        "上海市",
        "重庆市",
        "河北省",
        "山西省",
        "辽宁省",
        "吉林省",
        "黑龙江省",
        "江苏省",
        "浙江省",
        "安徽省",
        "福建省",
        "江西省",
        "山东省",
        "河南省",
        "湖北省",
        "湖南省",
        "广东省",
        "海南省",
        "四川省",
        "贵州省",
        "云南省",
        "陕西省",
        "甘肃省",
        "青海省",
        "台湾省",
        "内蒙古自治区",
        "广西壮族自治区",
        "西藏自治区",
        "宁夏回族自治区",
        "新疆维吾尔自治区",
        "香港特别行政区",
        "澳门特别行政区"
      ],
      cascaderPanel: false
    };
  },
  watch: {
    $route(val) {
      this.navActive = val.name;
    }
  },
  created() {
    this.navActive = this.$route.name;
  },
  methods: {
    navCat(p) {
      let path = p;
      if (path === "xf") {
        return window.open('http://www.gxanxun.com/app/index.html?xf')
      }
      if (path === "wb") {
        return window.open('http://www.gxanxun.com/app/index.html?wb')
      }
      if (path === "wb2") {
        return window.open('http://www.gxanxun.com/app/index.html?wb2')
      }
      if (typeof p === "object") {
        path = p[p.length - 1];
      }
      if (path === "joinUs") {
        this.dialogVisible = true;
      } else {
        this.navActive = path;
        this.$router.replace({
          path: `/${path}`
        });
      }
      this.cascaderPanel = false;
    },
    popConfirm() {
      for (let item in this.postData) {
        if (!this.postData[item]) {
          this.$message.warning("请填写完整加盟信息");
          return;
        }
      }
      this.$http.post(`${GoBaseUrl}/alliance`, this.postData).then(res => {
        if (res.code === 0) {
          this.$message.success("在线申请成功，请等待工作人员的联系");
          this.dialogVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#headers {
  width: 100%;
  height: 75px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  position: fixed;
  background: #fff;
  top: 0;
  left: 0;
  z-index: 100;
  .headerBox {
    max-width: 1200px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: relative;
    .flt {
      #logo {
        margin: 16px 0 0 5px;
        height: 40px;
      }
    }
    .navList {
      width: 750px;
      height: 100%;
      line-height: 75px;
      font-size: 16px;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      right: 0;
      .navCatList {
        width: 100%;
        height: 50px;
        padding-top: 12px;
        line-height: 50px;
        li {
          float: left;
          padding: 0 8px;
          margin: 0 8px;
          cursor: pointer;
          transition: all 0.3s;
        }
        li:hover {
          color: #073b7d;
          border-bottom: 2px solid #073b7d;
        }
        .navActive {
          color: #073b7d;
          border-bottom: 2px solid #073b7d;
        }
      }
      .el-menu-demo {
        margin-top: 10px;
      }
      .el-dropdown {
        display: none;
        float: right;
        margin-right: 10px;
      }
    }
    .phoneNav {
      padding: 15px;
    }
  }
  .el-cascader-panel {
    background: #fff;
  }
}
.joinDialog {
  .popContent {
    min-height: 1px;
    overflow: hidden;
    .popSun {
      width: 50%;
      height: 70px;
      label {
        width: 100px;
        line-height: 28px;
        display: block;
      }
      .el-radio {
        width: 45px;
        display: inline-block;
      }
      .el-input,
      .el-select {
        width: 200px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mains/headers.vue